export default {
    props: {
        contentUrl: {
            type: String,
            default: undefined,
            kComposite: 'content.url'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-popups-vue-wrapper/src/KendoTooltip/Content.js